import { EBookerLocationType } from '@/data/bookerData'

export const useBookerForm = () => {
	const bookingStore = useBookingStore()
	const bookerStore = useBookerStore()
	const { getStartDate, getEndDate } = useBookerService()

	const defaultStartDate = getStartDate()
	const defaultEndDate = getEndDate()

	const startLocation = computed<ILocationModel | null>({
		get: () => (bookingStore.getBookerLocations?.start as ILocationModel | null) ?? null,
		set: (value) =>
			bookingStore.setBookerLocations({
				start: value,
				end: (bookingStore.getBookerLocations?.end as ILocationModel | null) ?? null,
			}),
	})

	const endLocation = computed<ILocationModel | null>({
		get: () => (bookingStore.getBookerLocations?.end as ILocationModel | null) ?? null,
		set: (value) =>
			bookingStore.setBookerLocations({
				start: (bookingStore.getBookerLocations?.start as ILocationModel | null) ?? null,
				end: value,
			}),
	})

	const getLocation = (type: EBookerLocationType): ILocationModel | null =>
		type === EBookerLocationType.END ? endLocation.value : startLocation.value

	const setLocation = (type: EBookerLocationType, value: ILocationModel | null) => {
		if (type === EBookerLocationType.END) endLocation.value = value
		else startLocation.value = value
	}

	const dates = computed<{ start: Date; end: Date }>({
		get: () => ({
			start: bookingStore.getBookerDates?.start ?? defaultStartDate,
			end: bookingStore.getBookerDates?.end ?? defaultEndDate,
		}),
		set: (value) => bookingStore.setBookerDates({ start: value.start, end: value.end }),
	})

	const otherEndLocation = computed<boolean>({
		get: () => bookingStore.getIsOtherEndLocation,
		set: (value) => bookingStore.setOtherEndLocation(value),
	})

	const isStartLocationMenuOpen = computed<boolean>({
		get: () => bookerStore.getIsStartLocationMenuOpen,
		set: (value) => bookerStore.setIsStartLocationMenuOpen(value),
	})

	const isEndLocationMenuOpen = computed<boolean>({
		get: () => bookerStore.getIsEndLocationMenuOpen,
		set: (value) => bookerStore.setIsEndLocationMenuOpen(value),
	})

	const isStartDateMenuOpen = computed<boolean>({
		get: () => bookerStore.getIsStartDateMenuOpen,
		set: (value) => bookerStore.setIsStartDateMenuOpen(value),
	})

	const deliveryCosts = computed(() => bookerStore.getDeliveryCosts)

	return {
		startLocation,
		endLocation,
		getLocation,
		setLocation,
		dates,
		otherEndLocation,
		isStartLocationMenuOpen,
		isEndLocationMenuOpen,
		isStartDateMenuOpen,
		deliveryCosts,
	}
}
